import React, { forwardRef } from "react";
import PropTypes from "prop-types";

/** Lib Imports */
import { Card } from "primereact/card";

/** Components */
import ApplicantList from "../applicants/components/ApplicantList";

/** ENUM */
import {ApplicantStatus} from "../../enums/ApplicantStatus.ENUM";

const ScheduleInterview = forwardRef(
  ({ filters, searchApplicant, activeTab }, ref) => {
    return (
      <Card className="height-full-grid-with-searchbar schedule-interview-section">
        <div className="page-header">
          <div className="left-title-part">
            <h2 className="card-title  ">Schedule Interview</h2>
          </div>

        </div>
        <ApplicantList
          ref={ref}
          statusId={ApplicantStatus.SCHEDULE}
          filters={filters}
          searchApplicant={searchApplicant}
          activeTab={activeTab}
        />
      </Card>
    );
  },
);

ScheduleInterview.propTypes = {
  filters: PropTypes.object,
  searchApplicant: PropTypes.string,
  activeTab: PropTypes.number
};

export default ScheduleInterview;
